// Global Component JavaScript - Runs on all pages

export function init() {
    console.log('Global component initialized');

    // Initialize navigation
    initNavigation();

    // Initialize authentication modals
    initAuthModals();

    // Setup global HTMX configurations
    setupGlobalHTMX();

    // Initialize toast system
    initToastSystem();
}

function initNavigation() {
    // Add active state to current page link
    const currentPath = window.location.pathname;
    const navLinks = document.querySelectorAll('nav a[href]');

    navLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href === currentPath || (currentPath === '/' && href === '/')) {
            link.classList.add('text-indigo-200', 'font-semibold');
        }
    });
}

function initAuthModals() {
    // Guard against multiple initialization
    if (window._authModalsInitialized) {
        console.log('Auth modals already initialized, skipping');
        return;
    }
    window._authModalsInitialized = true;

    // Get modal elements
    const loginModal = document.getElementById('login-modal');
    const registerModal = document.getElementById('register-modal');
    const resetPasswordModal = document.getElementById('reset-password-modal');
    const dashboardModal = document.getElementById('dashboard-modal');

    if (!loginModal || !registerModal) {
        console.log('Auth modals not found on this page');
        return;
    }

    // Get form elements
    const loginForm = document.getElementById('login-form');
    const registerForm = document.getElementById('register-form');
    const resetPasswordForm = document.getElementById('reset-password-form');
    const addLoanForm = document.getElementById('add-loan-form');

    // Get button elements - Desktop
    const loginButton = document.getElementById('login-button');
    const registerButton = document.getElementById('register-button');
    const logoutButton = document.getElementById('logout-button');

    // Get button elements - Mobile
    const mobileLoginBtn = document.getElementById('mobile-login-button');
    const mobileRegisterBtn = document.getElementById('mobile-register-button');

    // Get modal switch buttons
    const modalRegisterButton = document.getElementById('modal-register-button');
    const modalLoginFromRegisterButton = document.getElementById('modal-login-from-register-button');
    const modalResetPasswordButton = document.getElementById('modal-reset-password-button');
    const modalLoginFromResetButton = document.getElementById('modal-login-from-reset-button');

    // Get close buttons
    const closeButtons = document.querySelectorAll('.modal .close-button');

    // Get other elements
    const subscribeButton = document.getElementById('subscribe-button');
    const loanCalculatorForm = document.getElementById('loan-calculator-form');

    // State
    let currentUser = null;
    let loans = [];
    let users = JSON.parse(localStorage.getItem('users')) || [];

    // --- Modal Functions ---
    function openModal(modal) {
        console.log('openModal called', modal ? modal.id : 'null');
        if (modal) {
            modal.style.display = 'block';
            modal.classList.add('show');
            document.body.style.overflow = 'hidden';
            console.log('Modal opened:', modal.id, 'display:', modal.style.display);
        }
    }

    function closeModal(modal) {
        console.log('closeModal called', modal ? modal.id : 'null');
        if (modal) {
            modal.classList.remove('show');
            modal.style.display = 'none';
            document.body.style.overflow = '';
            console.log('Modal closed:', modal.id);
        }
    }

    function closeAllModals() {
        [loginModal, registerModal, resetPasswordModal, dashboardModal].forEach(modal => {
            if (modal) {
                modal.classList.remove('show');
                modal.style.display = 'none';
            }
        });
        document.body.style.overflow = '';
    }

    // --- Event Listeners for opening modals ---

    console.log('Setting up modal event listeners');
    console.log('loginButton:', loginButton);
    console.log('registerButton:', registerButton);
    console.log('mobileLoginBtn:', mobileLoginBtn);
    console.log('mobileRegisterBtn:', mobileRegisterBtn);

    // Desktop login button
    if (loginButton) {
        loginButton.addEventListener('click', (e) => {
            console.log('Desktop login button clicked');
            e.preventDefault();
            e.stopPropagation();
            openModal(loginModal);
        });
    }

    // Desktop register button
    if (registerButton) {
        registerButton.addEventListener('click', (e) => {
            console.log('Desktop register button clicked');
            e.preventDefault();
            e.stopPropagation();
            openModal(registerModal);
        });
    }

    // Helper to close mobile nav
    function closeMobileNav() {
        const mobileNav = document.getElementById('mobile-nav');
        const hamburger = document.getElementById('hamburger');
        const overlay = document.getElementById('mobile-overlay');
        if (mobileNav) mobileNav.classList.remove('open');
        if (hamburger) hamburger.classList.remove('active');
        if (overlay) overlay.classList.add('hidden');
    }

    // Mobile login button
    if (mobileLoginBtn) {
        mobileLoginBtn.addEventListener('click', (e) => {
            console.log('Mobile login button clicked');
            e.stopPropagation();
            closeMobileNav();
            openModal(loginModal);
        });
    }

    // Mobile register button
    if (mobileRegisterBtn) {
        mobileRegisterBtn.addEventListener('click', (e) => {
            console.log('Mobile register button clicked');
            e.stopPropagation();
            closeMobileNav();
            openModal(registerModal);
        });
    }

    // Subscribe button
    if (subscribeButton) {
        subscribeButton.addEventListener('click', () => {
            if (currentUser) {
                showToast('Subscription activated! You will receive notifications about deals.', 'success');
            } else {
                showToast('Please log in or register to subscribe.', 'warning');
                openModal(loginModal);
            }
        });
    }

    // --- Event Listeners for closing modals ---

    // Close buttons (X)
    closeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            const modal = button.closest('.modal');
            closeModal(modal);
        });
    });

    // Click on modal background (overlay) to close
    [loginModal, registerModal, resetPasswordModal, dashboardModal].forEach(modal => {
        if (modal) {
            modal.addEventListener('click', (e) => {
                console.log('Modal backdrop clicked', modal.id, 'target:', e.target.id || e.target.className);
                // Only close if clicking directly on the modal background, not its children
                if (e.target === modal) {
                    console.log('Closing modal from backdrop click');
                    closeModal(modal);
                }
            });

            // Prevent clicks on modal content from closing
            const modalContent = modal.querySelector('.modal-content');
            if (modalContent) {
                modalContent.addEventListener('click', (e) => {
                    console.log('Modal content clicked, stopping propagation');
                    e.stopPropagation();
                });
            }
        }
    });

    // --- Event Listeners for switching between modals ---

    // Login -> Register
    if (modalRegisterButton) {
        modalRegisterButton.addEventListener('click', () => {
            closeModal(loginModal);
            openModal(registerModal);
        });
    }

    // Register -> Login
    if (modalLoginFromRegisterButton) {
        modalLoginFromRegisterButton.addEventListener('click', () => {
            closeModal(registerModal);
            openModal(loginModal);
        });
    }

    // Login -> Reset Password
    if (modalResetPasswordButton) {
        modalResetPasswordButton.addEventListener('click', () => {
            closeModal(loginModal);
            openModal(resetPasswordModal);
        });
    }

    // Reset Password -> Login
    if (modalLoginFromResetButton) {
        modalLoginFromResetButton.addEventListener('click', () => {
            closeModal(resetPasswordModal);
            openModal(loginModal);
        });
    }

    // --- Helper Functions ---

    function saveUsers() {
        localStorage.setItem('users', JSON.stringify(users));
    }

    function loadUsers() {
        try {
            const storedUsers = localStorage.getItem('users');
            users = storedUsers ? JSON.parse(storedUsers) : [];
        } catch (error) {
            console.error('Error loading users:', error);
            users = [];
            showToast('Error loading user data. Please try again.', 'error');
        }
    }

    function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function validatePassword(password) {
        return password.length >= 6;
    }

    function loadLoans() {
        if (currentUser) {
            loans = currentUser.loans || [];
        } else {
            loans = [];
        }
    }

    // --- Authentication ---

    // Register form
    if (registerForm) {
        registerForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const email = document.getElementById('register-email').value.trim();
            const password = document.getElementById('register-password').value.trim();

            if (!validateEmail(email)) {
                showToast('Invalid email address.', 'error');
                return;
            }

            if (!validatePassword(password)) {
                showToast('Password must be at least 6 characters long.', 'error');
                return;
            }

            if (users.find(user => user.email === email)) {
                showToast('Email already exists. Please login.', 'error');
                return;
            }

            const newUser = {
                email,
                password,
                loans: [],
                subscription: false,
            };
            users.push(newUser);
            saveUsers();
            currentUser = newUser;
            showToast('Registration successful. You are now logged in.', 'success');
            updateUI();
            closeModal(registerModal);
            openModal(dashboardModal);
        });
    }

    // Login form
    if (loginForm) {
        loginForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const email = document.getElementById('email').value.trim();
            const password = document.getElementById('password').value.trim();

            const user = users.find(u => u.email === email);
            if (!user || user.password !== password) {
                showToast('Invalid credentials. Please try again.', 'error');
                return;
            }

            currentUser = user;
            showToast('Login successful.', 'success');
            updateUI();
            closeModal(loginModal);
            openModal(dashboardModal);
        });
    }

    // Reset password form
    if (resetPasswordForm) {
        resetPasswordForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const email = document.getElementById('reset-email').value.trim();
            const user = users.find(u => u.email === email);
            if (!user) {
                showToast('Email not found. Please check the address.', 'error');
                return;
            }
            showToast('Password reset link sent to your email (simulated).', 'success');
            closeModal(resetPasswordModal);
            openModal(loginModal);
        });
    }

    // Logout
    if (logoutButton) {
        logoutButton.addEventListener('click', () => {
            currentUser = null;
            loans = [];
            localStorage.removeItem('current_user');
            closeModal(dashboardModal);
            showToast('Logged out.', 'info');
        });
    }

    // --- Loan Management ---

    // Loan calculator form (on homepage)
    if (loanCalculatorForm) {
        loanCalculatorForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const loanAmountInput = document.getElementById('loan-amount');
            const dueDateInput = document.getElementById('due-date');
            const loanCalculatorMessage = document.getElementById('loan-calculator-message');

            if (!loanAmountInput || !dueDateInput) return;

            const loanAmount = parseFloat(loanAmountInput.value);
            const dueDate = dueDateInput.value;

            if (isNaN(loanAmount) || loanAmount <= 0) {
                if (loanCalculatorMessage) {
                    loanCalculatorMessage.textContent = 'Please enter a valid loan amount.';
                    loanCalculatorMessage.className = 'mt-4 text-red-500';
                }
                return;
            }

            if (!dueDate) {
                if (loanCalculatorMessage) {
                    loanCalculatorMessage.textContent = 'Please enter a due date.';
                    loanCalculatorMessage.className = 'mt-4 text-red-500';
                }
                return;
            }

            if (loanCalculatorMessage) {
                loanCalculatorMessage.textContent = `Your loan of $${loanAmount} is due on ${dueDate}. You will receive reminders.`;
                loanCalculatorMessage.className = 'mt-4 text-green-600';
            }

            if (currentUser) {
                const newLoan = {
                    loanId: Math.random().toString(36).substr(2, 9),
                    loanType: 'Personal Loan',
                    dueDate: dueDate,
                    paymentAmount: loanAmount,
                    paymentStatus: false,
                    reminders: [],
                };

                currentUser.loans.push(newLoan);
                saveUsers();
                loadLoans();
                updateUI();
                showToast('Loan added to your dashboard.', 'success');
            }

            // Clear form
            loanAmountInput.value = '';
            dueDateInput.value = '';
        });
    }

    // Add loan form (in dashboard)
    if (addLoanForm) {
        addLoanForm.addEventListener('submit', (event) => {
            event.preventDefault();
            if (!currentUser) {
                showToast('Please log in to add a loan.', 'warning');
                return;
            }

            const loanType = document.getElementById('loan-type').value;
            const dueDate = document.getElementById('loan-due-date').value;
            const paymentAmount = parseFloat(document.getElementById('loan-payment-amount').value);

            if (!dueDate) {
                showToast('Please enter a due date.', 'error');
                return;
            }

            if (isNaN(paymentAmount) || paymentAmount <= 0) {
                showToast('Please enter a valid payment amount.', 'error');
                return;
            }

            const newLoan = {
                loanId: Math.random().toString(36).substr(2, 9),
                loanType,
                dueDate,
                paymentAmount,
                paymentStatus: false,
                reminders: [],
            };

            currentUser.loans.push(newLoan);
            saveUsers();
            loadLoans();
            updateUI();
            showToast('Loan added successfully.', 'success');
            addLoanForm.reset();
        });
    }

    // Mark loan as paid - expose globally for onclick handlers
    window.markLoanAsPaid = function(loanId) {
        if (!currentUser) return;

        const loan = currentUser.loans.find(l => l.loanId === loanId);
        if (loan) {
            loan.paymentStatus = true;
            saveUsers();
            loadLoans();
            updateUI();
            showToast('Payment confirmed.', 'success');
        } else {
            showToast('Loan not found.', 'error');
        }
    };

    // --- Reminder Generation ---
    function generateReminders() {
        if (!currentUser) return;

        const today = new Date();
        currentUser.loans.forEach(loan => {
            if (!loan.paymentStatus) {
                const dueDate = new Date(loan.dueDate);
                const daysUntilDue = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
                if (daysUntilDue <= 10 && daysUntilDue >= 0) {
                    const reminderSentToday = loan.reminders && loan.reminders.some(reminder => {
                        const reminderDate = new Date(reminder.date);
                        return reminderDate.getDate() === today.getDate() &&
                               reminderDate.getMonth() === today.getMonth() &&
                               reminderDate.getFullYear() === today.getFullYear();
                    });

                    if (!reminderSentToday) {
                        console.log(`Reminder: Payment of $${loan.paymentAmount} for ${loan.loanType} is due on ${loan.dueDate}`);
                        if (!loan.reminders) loan.reminders = [];
                        loan.reminders.push({
                            date: today,
                            sent: true,
                        });
                        saveUsers();
                    }
                }
            }
        });
    }

    // --- UI Updates ---
    function updateUI() {
        const upcomingPaymentsList = document.getElementById('upcoming-payments-list');
        const paymentHistoryList = document.getElementById('payment-history-list');
        const noUpcomingPaymentsMessage = document.getElementById('no-upcoming-payments');
        const noPaymentHistoryMessage = document.getElementById('no-payment-history');
        const debtAnalysisText = document.getElementById('debt-analysis-text');
        const totalDebtAmountDisplay = document.getElementById('total-debt-amount');

        if (!upcomingPaymentsList || !paymentHistoryList) return;

        upcomingPaymentsList.innerHTML = '';
        paymentHistoryList.innerHTML = '';
        let totalDebt = 0;
        let hasUpcomingPayments = false;
        let hasPaymentHistory = false;

        loadLoans();

        loans.forEach(loan => {
            totalDebt += loan.paymentAmount;

            if (!loan.paymentStatus) {
                hasUpcomingPayments = true;
                const listItem = document.createElement('li');
                listItem.className = 'bg-white rounded-md shadow-sm py-2 px-3 mb-2 flex justify-between items-center';
                listItem.innerHTML = `
                    <div>
                        <h4 class="text-md font-semibold text-gray-800">${loan.loanType} - Due: ${loan.dueDate}</h4>
                        <p class="text-sm text-gray-600">Amount: $${loan.paymentAmount}</p>
                    </div>
                    <button class="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline text-xs" onclick="markLoanAsPaid('${loan.loanId}')">Did you pay?</button>
                `;
                upcomingPaymentsList.appendChild(listItem);
            } else {
                hasPaymentHistory = true;
                const listItem = document.createElement('li');
                listItem.className = 'bg-gray-50 rounded-md shadow-sm py-2 px-3 mb-2';
                listItem.innerHTML = `
                    <h4 class="text-md font-semibold text-gray-600">${loan.loanType} - Paid on: ${loan.dueDate}</h4>
                    <p class="text-sm text-gray-500">Amount: $${loan.paymentAmount}</p>
                `;
                paymentHistoryList.appendChild(listItem);
            }
        });

        if (totalDebtAmountDisplay) {
            totalDebtAmountDisplay.textContent = totalDebt.toFixed(2);
        }

        if (noUpcomingPaymentsMessage) {
            if (!hasUpcomingPayments) {
                noUpcomingPaymentsMessage.classList.remove('hidden');
            } else {
                noUpcomingPaymentsMessage.classList.add('hidden');
            }
        }

        if (noPaymentHistoryMessage) {
            if (!hasPaymentHistory) {
                noPaymentHistoryMessage.classList.remove('hidden');
            } else {
                noPaymentHistoryMessage.classList.add('hidden');
            }
        }

        if (debtAnalysisText) {
            if (totalDebt > 10000) {
                debtAnalysisText.textContent = 'Your total debt is significant. Consider exploring debt consolidation or refinancing options.';
            } else if (totalDebt > 5000) {
                debtAnalysisText.textContent = 'You have a moderate amount of debt. Making consistent payments is important.';
            } else {
                debtAnalysisText.textContent = 'Your debt is relatively low. Keep up the good work managing your finances!';
            }
        }
    }

    // --- Initialization ---
    loadUsers();
    loadLoans();
    updateUI();
    generateReminders();

    // Set up interval for generating daily reminders
    setInterval(generateReminders, 24 * 60 * 60 * 1000);

    // Expose functions globally for external use
    window.openModal = openModal;
    window.closeModal = closeModal;
    window.loginModal = loginModal;
    window.registerModal = registerModal;

    console.log('Auth modals initialized');
}

function setupGlobalHTMX() {
    if (!window.htmx) return;

    // Configure HTMX globally
    htmx.config.defaultSwapStyle = 'innerHTML';
    htmx.config.defaultSwapDelay = 0;
    htmx.config.defaultSettleDelay = 20;

    // Add CSRF token to all requests if available
    document.body.addEventListener('htmx:configRequest', (event) => {
        const csrfToken = document.querySelector('meta[name="csrf-token"]');
        if (csrfToken) {
            event.detail.headers['X-CSRF-Token'] = csrfToken.content;
        }
    });

    // Global error handling
    document.body.addEventListener('htmx:responseError', (event) => {
        console.error('HTMX request failed:', event.detail);
        showToast('An error occurred. Please try again.', 'error');
    });

    // Loading indicators
    document.body.addEventListener('htmx:beforeRequest', (event) => {
        const trigger = event.detail.elt;
        if (trigger.dataset.loading) {
            trigger.disabled = true;
            trigger.dataset.originalText = trigger.textContent;
            trigger.textContent = trigger.dataset.loading;
        }
    });

    document.body.addEventListener('htmx:afterRequest', (event) => {
        const trigger = event.detail.elt;
        if (trigger.dataset.originalText) {
            trigger.textContent = trigger.dataset.originalText;
            trigger.disabled = false;
            delete trigger.dataset.originalText;
        }
    });

    console.log('HTMX global configuration complete');
}

function initToastSystem() {
    // Create global toast function
    window.showToast = showToast;
}

function showToast(message, type = 'success') {
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.textContent = message;
    document.body.appendChild(toast);

    // Auto-hide after 3 seconds
    setTimeout(() => {
        toast.classList.add('fade-out');
        setTimeout(() => toast.remove(), 500);
    }, 3000);
}

// Debug helper
function addDebugEntry(data, source, description) {
    if (window.console && window.location.search.includes('debug=true')) {
        console.group(`Debug: ${description}`);
        console.log('Source:', source);
        console.log('Data:', data);
        console.log('Timestamp:', new Date().toISOString());
        console.groupEnd();
    }
}

// Export functions
export {
    showToast,
    addDebugEntry,
    setupGlobalHTMX
};
